<template>
  <div class="container-fluid pb-4 f14 color-black">
    <div class="row mb-4">
      <div class="col-lg-12 col-xs-12">
        <h2 class="mt-3">ATIVIDADES/CURSOS EXTRA CURRICULARES</h2>
      </div>
    </div>
    <div class="row">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2">ATIVIDADE/CURSO</span>
        <span class="color-red font-weight-bold">*</span>
        <div>
          <VueSuggestion
            v-model="extra_course.name"
            :searchURL="`${
              candidate_id
                ? `/recruiters/talent_banks/${candidate_id}/extra_courses`
                : `/candidates/extra_courses/`
            }`"
            :selectedEl="extra_course"
            :whenSelected="
              (item) => {
                extra_course = item;
              }
            "
            classes="mt-1"
            placeholder="INFORME AQUI"
            responseDataName="extra_courses"
            style="text-transform: capitalize"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span class="font-weight-bold">TIPO</span>
        <div
          class="select nav-tabs mt-1 p-0 block_info_white d-flex align-items-center"
        >
          <select v-model="type_activity" class="form-control">
            <option
              v-for="activity in activitiesType"
              :key="activity.value"
              :value="activity.value"
            >
              {{ activity.text }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-8 col-xs-12">
        <span class="font-weight-bold ml-2 mb-2"
          >INSTITUIÇÃO (SE APLICÁVEL)</span
        >
        <VueSuggestion
          v-model="institution.name"
          :clearOption="true"
          :selectedEl="institution"
          :whenSelected="
            (item) => {
              institution = item;
            }
          "
          classes="mt-1"
          placeholder="INSTITUIÇÃO QUE VOCÊ ESTUDOU..."
          responseDataName="institutions"
          searchURL="/institutions"
          style="text-transform: capitalize"
        />
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-lg-3 col-xs-12">
        <span
          :class="{ 'text-danger': errors.start_date }"
          class="font-weight-bold"
        >
          DATA DE INÍCIO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            v-model="start_date"
            v-mask="['##/####']"
            :class="{ 'is-invalid': errors.start_date }"
            class="vs__input"
            placeholder="mês/ano"
            type="text"
            @focus="errors.start_date = false"
          />
        </div>
      </div>
      <div class="col-lg-4 col-xs-12">
        <span
          :class="{ 'text-danger': errors.end_date }"
          class="font-weight-bold text-nowrap mt-2"
        >
          DATA DE TÉRMINO OU PREVISÃO DE TÉRMINO
        </span>
        <span class="color-red font-weight-bold">*</span>
        <div class="vs__input-group mt-1">
          <input
            v-model="end_date"
            v-mask="['##/####']"
            :class="{ 'is-invalid': errors.end_date }"
            class="vs__input"
            placeholder="mês/ano"
            type="text"
            @focus="errors.end_date = false"
          />
        </div>
      </div>
    </div>
    <div class="row mt-2">
      <div class="col-lg-12 col-xs-12">
        <span class="font-weight-bold">DESCRIÇÃO</span>
        <div class="mt-1">
          <textarea
            v-model="description"
            class="full form-control"
            cols="30"
            rows="10"
            style="height: 100px; border-radius: 5px"
            maxlength="610"
          ></textarea>
          <div class="d-flex justify-content-end">
            <small class="form-text text-muted">{{ description.length }}/610</small>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-2">
        <button
          class="btn-add-items-tb bg-purple color-white right"
          style="min-width: 300px"
          @click="createOrUpdate()"
        >
          SALVAR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import VueSuggestion from "components/VueSuggestion.vue";
import { format } from "date-fns";
import axios from "axios";

export default {
  props: ["extra_course_id", "candidate_id"],
  components: { VueSuggestion },
  mounted() {
    if (this.extra_course_id) {
      let url = `/candidates/extra_courses/${this.extra_course_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses/${this.extra_course_id}`;
      }
      axios.get(url).then((response) => {
        let extra_course = response.data.extra_course;

        this.extra_course.name = extra_course.name.toLowerCase();
        this.institution.id = extra_course.institution_id;
        this.institution.name = extra_course.institution_name.toLowerCase();
        this.start_date = extra_course.start_date
          ? format(new Date(extra_course.start_date), "MM/yyyy")
          : "";
        this.end_date = extra_course.end_date
          ? format(new Date(extra_course.end_date), "MM/yyyy")
          : "";
        this.description = extra_course.description;
        this.type_activity = extra_course.type_activity;
      });
    }
  },
  data: () => ({
    start_date: "",
    end_date: "",
    description: "",
    type_activity: null,
    institution: {
      id: 0,
      name: "",
    },
    extra_course: {
      name: "",
    },
    errors: {
      start_date: false,
      end_date: false,
    },
    activitiesType: [
      { value: 0, text: "Intercâmbio" },
      { value: 1, text: "Pesquisa Acadêmica" },
      { value: 2, text: "Empresa Júnior" },
      { value: 3, text: "Cursos Extracurriculares" },
      { value: 4, text: "Outras Atividades Extracurriculares" },
    ],
  }),
  computed: {
    params() {
      let extra_courses = {
        description: this.description,
        candidate_id: this.candidate_id,
        start_date: this.formatDate(this.start_date),
        end_date: this.formatDate(this.end_date),
        name: this.extra_course.name.toLowerCase(),
        institution: this.institution.name.toLowerCase(),
        type_activity: this.type_activity,
      };
      return extra_courses;
    },
  },
  methods: {
    createOrUpdate() {
      if (!this.validForm()) return;
      if (!this.validDate(this.start_date, "start_date")) return;
      if (!this.validDate(this.end_date, "end_date")) return;

      if (this.extra_course_id) {
        this.updateExtraCourse();
        return;
      }

      this.createExtraCourse();
    },
    createExtraCourse() {
      let url = `/candidates/extra_courses/`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses/`;
      }
      axios
        .post(url, {
          extra_courses: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    updateExtraCourse() {
      let url = `/candidates/extra_courses/${this.extra_course_id}`;
      if (this.candidate_id) {
        url = `/recruiters/talent_banks/${this.candidate_id}/extra_courses/${this.extra_course_id}`;
      }
      axios
        .put(url, {
          extra_courses: this.params,
        })
        .then((response) => {
          this.sendFeedback(response.data.status);
        });
    },
    sendFeedback(status) {
      if (!status) {
        this.$toast.error("Sinto muito, não foi possivel salvar.");
        return;
      }

      this.$toast.success("Atividade/Curso extracurricular salvo com sucesso!");
      eventBus.$emit("getExtraCourses");
      eventBus.$emit("updateInfo");
      this.$modal.hideAll();
    },
    validForm() {
      let fields = [
        { name: "Curso", value: this.extra_course.name },
        { name: "Ano de inicio", value: this.start_date },
        { name: "Ano de término", value: this.end_date },
      ];

      for (let field of fields) {
        if (field.value.length === 0) {
          this.$toast.error(`O campo "${field.name}" não pode ficar vazio.`);
          return false;
        }
      }

      return true;
    },
    validDate(dateStr, field) {
      if (dateStr.length === 0) {
        this.$toast.error("Por favor, preencha o campo corretamente.");
        this.errors[field] = true;
        return false;
      }

      let month = parseInt(dateStr.slice(0, dateStr.indexOf("/")));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      if (field === "start_date") {
        const start_date = new Date(year, month - 1, "01");
        const today = new Date();
        if (start_date > today) {
          this.errors[field] = true;
          return false;
        }
      }

      if (month === 0 || month > 12) {
        this.$toast.error("Data invalida.");
        this.errors[field] = true;
        return false;
      }

      if (year <= 1960 || year >= 2050) {
        this.$toast.error("Data invalida, insira um ano valido.");
        this.errors[field] = true;
        return false;
      }

      return true;
    },
    formatDate(dateStr) {
      let month = dateStr.slice(0, dateStr.indexOf("/"));
      let year = dateStr.slice(dateStr.indexOf("/") + 1);

      return year.concat("/", month, "/01");
    },
  },
};
</script>
